import React from 'react';
import { MyContext } from '../../InitialSetup/MyProvider';
import { Helmet } from "react-helmet";
import { Utilities } from '../../Utilities/Utilities';
import { getUserProfile, getUserBalance, withdrawPending } from '../../WSHelper/WSCallings';
import * as WSC from "../../WSHelper/WSConstants";
import * as AppLabels from "../../helper/AppLabels";
import WSManager from "../../WSHelper/WSManager";
import ls from 'local-storage';
import MetaData from "../../helper/MetaData";
import CustomHeader from '../../components/CustomHeader';
import { UserWinning, DataCountBlock } from "../CustomComponent";
import { OnlyCoinsFlow, AllowRedeem } from '../../helper/Constants';
import Images from '../../components/images';
import {DownloadAppBuyCoinModal} from "../../Modals";

export default class Wallet extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            userBalance: "",
            userBalObj: "",
            allowedBonusPercantage: "",
            winningAmt: "",
            profileDetail: WSManager.getProfile(),
            verificationSteps: '',
            bonusCash: '',
            depositAmt: '',
            coin_balance: '',
            withdrawStatus: '',
            allow_withdraw: 0,
            accVerified: this.isAccountVerified(WSManager.getProfile()),
            wallet_content:'',
            showDAM : false
        }
    }

    componentDidMount() {
        Utilities.handleAppBackManage('my-wallet')
        this.callProfileDetail();
        this.callUserBalanceApi();
        this.showRedeemCM(WSManager.getProfile());
        this.handelBycoinAppEvent();


    }

    handelBycoinAppEvent() {
        window.addEventListener('message', (e) => {
           if (e.data.action == 'buyCoin' && e.data.type == 'succuss') {
                this.callUserBalanceApi();
              }
            
        });
    }


    showRedeemCM = (data) => {
        if (Utilities.getMasterData().a_coin !== "0") {
            if (data.user_setting && data.user_setting.redeem == "0" && AllowRedeem) {
                CustomHeader.showRedeemCM();
            }
        }
    }


    isAccountVerified = (data) => {
        let m_e_p_b = Utilities.getMasterData().m_e_p_b;
        let tmpArray = m_e_p_b.split('_');
        let mobOptional = tmpArray.length > 0 ? parseInt(tmpArray[0]) : 1;
        let emailOptional = tmpArray.length > 1 ? parseInt(tmpArray[1]) : 1;
        let panOptional = tmpArray.length > 2 ? parseInt(tmpArray[2]) : 1;
        let bankOptional = tmpArray.length > 3 ? parseInt(tmpArray[3]) : 1;
        return ((data.pan_verified == "1" || panOptional === 0) && (data.is_bank_verified == "1" || bankOptional === 0) && (data.email_verified == "1" || emailOptional === 0) && (data.phone_verfied == "1" || mobOptional === 0)) ? true : false
    }

    goToAddFunds() {
        this.props.history.push({ pathname: '/add-funds', state: {} })
    }
    goToWithdraw() {
        if (this.state.accVerified) {
            this.props.history.push({ pathname: '/withdraw', state: { withdrawStatus: this.state.withdrawStatus, isFromWallet: true, allow_withdraw: this.state.allow_withdraw } })
        }
    }
    goToTransList() {
        this.props.history.push({ pathname: '/transactions', state: {} })
    }
    goToContactUs() {
        this.props.history.push({ pathname: '/contact-us', state: {} })
    }

    callProfileDetail() {
        getUserProfile().then((responseJson) => {
            if (responseJson && responseJson.response_code == WSC.successCode) {
                ls.set('profile', responseJson.data)
                this.setState({
                    profileDetail: responseJson.data,
                    accVerified: this.isAccountVerified(responseJson.data)
                })
            }
        })
    }

    withdrawPendingApi() {
        withdrawPending().then((responseJson) => {
            if (responseJson && responseJson.response_code == WSC.successCode) {
                this.setState({
                    withdrawStatus: responseJson.data.pending_request,
                    allow_withdraw: responseJson.data.allow_withdraw
                })
            }
        })
    }
    callUserBalanceApi() {
        getUserBalance().then((responseJson) => {
            if (responseJson.response_code == WSC.successCode) {
                this.setState({
                    userBalance: Utilities.getTotalBalance(responseJson.data.user_balance),
                    winningAmt: responseJson.data.user_balance.winning_amount,
                    bonusCash: Utilities.getMasterData().currency_code + responseJson.data.user_balance.bonus_amount,
                    depositAmt: Utilities.getMasterData().currency_code + responseJson.data.user_balance.real_amount,
                    coin_balance : responseJson.data.user_balance.point_balance,
                    wallet_content: responseJson.data.wallet_content,
                    userBalObj: responseJson.data.user_balance

                })
                WSManager.setBalance(responseJson.data.user_balance);
            }
            this.withdrawPendingApi()
        })
    }

    goToVerifyAccount() {
        this.props.history.push({
            pathname: '/verify-account',
            state: {
                email_verified: this.state.profileDetail.email_verified,
                phone_verfied: this.state.profileDetail.phone_verfied,
                pan_verified: this.state.profileDetail.pan_verified,
                is_bank_verified: this.state.profileDetail.is_bank_verified
            }
        })
    }

    coinAction = (coin_balance) => {
        if(coin_balance == 0 || AllowRedeem === false){
            this.props.history.push({ pathname: "/earn-coins" });
        }else{
            this.props.history.push({ pathname: "/rewards" });
        }
    }

    goToBuyCoins = () => {

        if (OnlyCoinsFlow == 1 || OnlyCoinsFlow == 2) {
            if (window.ReactNativeWebView) {
                let data = {
                    action: 'openBuyScreen',
                    targetFunc: 'openBuyScreen'
                }
                window.ReactNativeWebView.postMessage(JSON.stringify(data));
            } else {
                this.showDownloadApp();
            }
        } else {
            this.props.history.push({ pathname: "/buy-coins", state: { userBalance: this.state.userBalObj } });
        }
    }

    showDownloadApp=()=>{
        this.setState({
            showDAM : true
        })
    }

    hideDownloadApp=()=>{
        this.setState({
            showDAM : false
        })
    }

    render() {
        const HeaderOption = {
            back: true,
            notification: true,
            title: AppLabels.MY_WALLET,
            hideShadow: true
        }

        const { accVerified, withdrawStatus, allow_withdraw, coin_balance, wallet_content, showDAM } = this.state;

        return (
            <MyContext.Consumer>
                {(context) => (
                    <div className="web-container transparent-header web-container-fixed wallet-wrapper">
                        <Helmet titleTemplate={`${MetaData.template} | %s`}>
                            <title>{MetaData.mywallet.title}</title>
                            <meta name="description" content={MetaData.mywallet.description} />
                            <meta name="keywords" content={MetaData.mywallet.keywords}></meta>
                        </Helmet>
                        {!this.props.hideHeader &&
                            <CustomHeader {...this.props} HeaderOption={HeaderOption} />
                        }
                        <div className={"wallet-header header-with-circle" + (accVerified || OnlyCoinsFlow == 1 || OnlyCoinsFlow == 2 ? '' : ' wallet-header-with-verify')}>
                            <div className="overlay-white-circle"></div>
                            <div className="wallet-cont">
                            <div className="acc-bal">{ OnlyCoinsFlow == 1 ? <img className="coin-img" src={Images.IC_COIN} alt="" /> : Utilities.getMasterData().currency_code} {(OnlyCoinsFlow == 1 ? Math.ceil(coin_balance) : this.state.userBalance) || '--'}</div>
                            {
                                (wallet_content && wallet_content.header)
                                ? <div className="total-bal-text">{wallet_content.header}</div>
                                : <div className="total-bal-text">{AppLabels.TOTAL_BALANCE}</div>
                            }
                            {
                                (wallet_content && wallet_content.body)
                                ? <div className="bal-summary">{wallet_content.body}</div>
                                : <div className="bal-summary">{AppLabels.WINNINGS} + {AppLabels.BONUS_CASH} + {AppLabels.DEPOSIT}</div>
                            }
                            {/* <div className="currency-circle">
                                <i className="icon-no-currency"/>
                            </div> */}
                            {(OnlyCoinsFlow != 1 && OnlyCoinsFlow != 2) && <div className="add-cash-btn">
                                <a href className="btn btn-primary btn-rounded" onClick={() => this.goToAddFunds()}>{AppLabels.ADD_CASH}</a>
                            </div>}
                            </div>
                        </div>
                        <div className={"wallet-body" + (accVerified ? '' : ' wallet-body-with-verify') + ((OnlyCoinsFlow == 1 || OnlyCoinsFlow == 2) ? ' coin-only-head' : '')}>
                            {this.state.winningAmt && (OnlyCoinsFlow != 1 && OnlyCoinsFlow != 2) &&
                                <UserWinning
                                    winningAmt={this.state.winningAmt}
                                    goToVerifyAccount={() => this.goToVerifyAccount()}
                                    StepList={this.state.verificationSteps}
                                    IsProfileVerifyShow={accVerified}
                                />
                            }
                            {
                            Utilities.getMasterData().a_coin == 1 && <DataCountBlock item={
                                    {
                                        'icon': 'icon-coins-bal-ic',
                                        'count': Math.ceil(coin_balance),
                                        'count_for': AppLabels.COINS_BALANCE,
                                        'isCoin' : true
                                    }
                                }
                                    onClick={(e) =>{e.stopPropagation();  this.coinAction(coin_balance)}}
                                    onBuyCoins={(e)=>{e.stopPropagation();this.goToBuyCoins()}}
                            />
                            }
                            {
                                OnlyCoinsFlow != 1 && <div className="bal-summary-wrap m-t-20 m-b-20">
                                    <div className="display-table-row">
                                        <div className={"cash-summary-with-amt" + (OnlyCoinsFlow == 2 ? ' p-0' : '')}>
                                            <DataCountBlock item={
                                                {
                                                    'icon': 'icon-bonus1',
                                                    'count': this.state.bonusCash,
                                                    'count_for': AppLabels.BONUS_CASH
                                                }
                                            }
                                                countInt={true}
                                            />
                                        </div>
                                        {
                                            OnlyCoinsFlow != 2 && <div className="cash-summary-with-amt">
                                                <DataCountBlock item={
                                                    {
                                                        'icon': 'icon-deposit',
                                                        'count': this.state.depositAmt,
                                                        'count_for': AppLabels.DEPOSIT
                                                    }
                                                }
                                                    countInt={true}
                                                />
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                            <div className="cash-action">
                                {
                                    (OnlyCoinsFlow != 1 && OnlyCoinsFlow != 2) && <DataCountBlock item={
                                        {
                                            'icon': 'icon-add-cash',
                                            'count': AppLabels.ADD_CASH,
                                            'count_for': AppLabels.PAY_WITH_DEBIT_CARD_CREDIT_CARD_UPI_MORE,
                                        }
                                    }
                                        onClick={() => this.goToAddFunds()}
                                        countInt={false}
                                    />
                                }
                                {
                                    withdrawStatus !== '' && (OnlyCoinsFlow != 1 && OnlyCoinsFlow != 2) &&
                                    <DataCountBlock item={
                                        {
                                            'icon': 'icon-withdraw',
                                            'count': AppLabels.WITHDRAW_MONEY,
                                            'count_for': (allow_withdraw !== 0) ? (accVerified ? AppLabels.WITHDRAW_YOUR_WINNINGS_IN_YOUR_ACCOUNT : (`${AppLabels.VERIFY_YOUR_ACCOUNT_FIRST} (${AppLabels.MIN_WITHDRAW_LIMIT} 50)`)) : AppLabels.YOUR_WITHDRAWAL_REQUEST_IS_PENDING
                                        }
                                    }
                                        onClick={() => this.goToWithdraw()}
                                        countInt={false}
                                        showPendingIcon={allow_withdraw === 0}
                                    />
                                }
                                <DataCountBlock item={
                                    {
                                        'icon': 'icon-transaction',
                                        'count': AppLabels.TRANSACTION_HISTORY,
                                        'count_for': AppLabels.WHERE__HOW_MUCH_SPENT_KNOW_ALL
                                    }
                                }
                                    onClick={() => this.goToTransList()}
                                    countInt={false}
                                />
                                <DataCountBlock item={
                                    {
                                        'icon': 'icon-support',
                                        'count': AppLabels.NEED_HELP,
                                        'count_for': AppLabels.HRS24_SUPPORT
                                    }
                                }
                                    onClick={() => this.goToContactUs()}
                                />
                            </div>
                        </div>
                        {
                            showDAM &&
                            <DownloadAppBuyCoinModal
                                hideM={this.hideDownloadApp}
                            />
                        }
                    </div>
                )}
            </MyContext.Consumer>
        )
    }
}